"use strict";
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericCheckBoxGroupFilter = GenericCheckBoxGroupFilter;
const react_1 = __importDefault(require("react"));
const CheckBoxGroup_1 = require("../CheckBoxGroup");
/** Generic filter component that can work with any list of string options */
function GenericCheckBoxGroupFilter({ options, selectedValues = [], onSelect, onDeselect, onChange, padding = "5px 0px 0px 5px", style, className, getTranslationKey, }) {
    const handleSelect = (value) => {
        if (onSelect) {
            onSelect(value);
        }
        if (onChange) {
            const newSelection = [...selectedValues, value];
            onChange(newSelection);
        }
    };
    const handleDeselect = (value) => {
        if (onDeselect) {
            onDeselect(value);
        }
        if (onChange) {
            const newSelection = selectedValues.filter((v) => v !== value);
            onChange(newSelection);
        }
    };
    return (react_1.default.createElement("div", { style: style, className: className },
        react_1.default.createElement(CheckBoxGroup_1.CheckboxGroup
        // @ts-ignore – it's still an array of strings really.
        , { 
            // @ts-ignore – it's still an array of strings really.
            types: options, activeTypes: selectedValues, select: handleSelect, deselect: handleDeselect, padding: padding, getTranslationKey: getTranslationKey })));
}
//# sourceMappingURL=GenericCheckBoxGroupFilter.js.map